module.exports = __webpack_public_path__ + "img/level_up.07e28d76.jpg";